import { useEffect } from 'react';
import seo from '../config/seo-origin.json';

const upsertMeta = (attribute, key, content) => {
    if (!content) return;
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute('content', content);
};

const BlogSeo = ({ title, description, socialDescription, canonicalPath, image, imageAlt, noIndex = false }) => {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title || 'SafeVault Blogs';

        upsertMeta('name', 'description', description);
        upsertMeta('property', 'og:title', title);
        upsertMeta('property', 'og:description', socialDescription || description);
        upsertMeta('property', 'og:type', 'article');
        upsertMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');
        upsertMeta('name', 'author', 'Raman Yakkala');
        upsertMeta('name', 'publisher', 'AmitaSoft, LLC');
        upsertMeta('property', 'og:site_name', 'SafeVault');
        upsertMeta('name', 'twitter:creator', '@Safevault125672');
        upsertMeta('name', 'twitter:title', title);
        upsertMeta('name', 'theme-color', '#0f172a');

        upsertMeta('name', 'twitter:description', socialDescription || description);

        if (canonicalPath) {
            const canonicalUrl = `${seo.origin}${canonicalPath}`;
            upsertMeta('property', 'og:url', canonicalUrl);

            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', canonicalUrl);
        }

        if (image) {
            const imageUrl = image.startsWith('http') ? image : `${seo.origin}${process.env.PUBLIC_URL || ''}${image}`;
            upsertMeta('property', 'og:image', imageUrl);
            upsertMeta('name', 'twitter:image', imageUrl);
            upsertMeta('property', 'og:image:alt', imageAlt);
        }

        return () => {
            document.title = previousTitle;
        };
    }, [title, description, socialDescription, canonicalPath, image, imageAlt, noIndex]);

    return null;
};

export default BlogSeo;
